import Crud from '../views/Refueling/Crud'
import Entity from '../views/Refueling/Add'
import View from "../views/Refueling/View.vue";

let routes = {
    path: '/refuelings',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/refuelings/add',
            name: 'NewRefueling',
            component: Entity,
            meta: {
                ability: 'abastecimentos.gerenciar',
                pageTitle: 'Refueling',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/refuelings'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/refuelings/edit/:id?',
            name: 'EditRefueling',
            component: Entity,
            meta: {
                ability: 'abastecimentos.gerenciar',
                pageTitle: 'Refueling',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/refuelings'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/refuelings',
            name: 'list-refuelings',
            component: Crud,
            meta: {
                ability: 'abastecimentos.ver',
                pageTitle: 'Refueling',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/refuelings/view/:id?',
            name: 'ViewRefueling',
            component: View,
            meta: {
                ability: 'abastecimentos.ver',
                pageTitle: 'Refueling',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/refuelings'
                    },
                    {
                        text: 'View',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
